import React, { useMemo } from 'react';

import cn from 'classnames';

import { useSpeakerAssociations } from '../../../apis/useSpeakerAssociations';
import { OxygenPersonItem } from '../../../common/interface';
import User, { UserSkeleton } from '../user';

export interface Props {
  oxygenIds?: OxygenPersonItem[];
  contentId?: string;
  userProfileURL?: string;
  userContentURL?: string;
  max?: number;
}

function UserNamesList({
  contentId = '',
  oxygenIds,
  userProfileURL,
  userContentURL,
  max = 2,
}: Props) {
  const contentIdMode =
    typeof contentId === 'string' && contentId.length > 0 && !oxygenIds;

  const oxygenIdsMode =
    !contentIdMode && Array.isArray(oxygenIds) && oxygenIds.length > 0;

  const { data, isLoading } = useSpeakerAssociations({
    contentId,
    baseURL: userContentURL,
    enabled: contentIdMode,
  });

  const userIds = useMemo(() => {
    if (oxygenIdsMode) {
      return oxygenIds;
    }
    if (contentIdMode) {
      return data;
    }
    return [];
  }, [contentIdMode, oxygenIdsMode, oxygenIds, data]);

  const displayLoading = contentIdMode && isLoading;
  return (
    <div className="au-usernames-list au-text-[14px] au-uppercase au-mt-6 lg:au-mt-4">
      {displayLoading ? (
        <UserSkeleton showBio={false} showPicture={false} size="small" />
      ) : null}
      {!displayLoading && userIds.length > 0
        ? userIds.slice(0, max).map(({ personId }, i) => (
            <div key={personId} className="au-inline-flex au-user">
              <User
                bypassCache={false}
                showFlyout
                showBio={false}
                showPicture={false}
                oxygenId={personId}
                hasLink
                userProfileURL={userProfileURL}
                userContentURL={userContentURL}
                size="small"
                isSpeaker
                showComma={userIds.length > 1 && i < max - 1}
              />
            </div>
          ))
        : null}
      {!displayLoading && userIds.length > max ? (
        <div className={cn('au-flex')}>
          <div className="au-font-element au-mr-1 au-text-base au-leading-c17 au-tracking-wider au-ml-1.5">{`+${
            userIds.length - max
          } more`}</div>
        </div>
      ) : null}
    </div>
  );
}

export default UserNamesList;
